module.exports = __webpack_public_path__ + "img/imagen7.8e3ec3d5.png";